// extracted by mini-css-extract-plugin
export default {"p":"_58b4f66a81 _62ad79b94d _303eab5370","clr":"_0f82fe6cd3","dls":"_0cea70473a"};